import http from './http';

class CompaniesService {
  static getCompanies() {
    return http.get('/users/companies');
  }
}
export default CompaniesService;
